import React, { createContext, useContext, useState, ReactNode } from 'react';

export interface Team {
    id: string;
    name: string;
}

interface TeamContextType {
    eligibleTeams: Team[];
    setEligibleTeams: (teams: Team[]) => void;
    selectedTeamId: string;
    setSelectedTeamId: (id: string) => void;
}

const TeamContext = createContext<TeamContextType | undefined>(undefined);

export const useTeamContext = () => {
    const ctx = useContext(TeamContext);
    if (!ctx) throw new Error('useTeamContext must be used within TeamProvider');
    return ctx;
};

export const TeamProvider = ({ children }: { children: ReactNode }) => {
    const [eligibleTeams, setEligibleTeams] = useState<Team[]>([]);
    const [selectedTeamId, setSelectedTeamId] = useState<string>('');
    return (
        <TeamContext.Provider value={{ eligibleTeams, setEligibleTeams, selectedTeamId, setSelectedTeamId }}>
            {children}
        </TeamContext.Provider>
    );
};
